import { BaseComponent } from "../../../abstract/base.component";
import { Directive } from "@angular/core";

@Directive()
export abstract class AddCardAction extends BaseComponent {
  protected _addCardToCustomerUrl: string;
  protected _addSource: string;

  createCardOnApi(card) {
    this.loadFlag = true;
    this.dataManager
      .postRequest(this._addCardToCustomerUrl, card, 0)
      .subscribe(
        (response) => {
          this.loadFlag = false;
          this.passResponse(response);
        },
        (error) => {
          console.log(error);
          this.loadFlag = false;
          this.passError(error.error);
        }
      );
  }
  addSourceToCustomer(postBody) {
    this.loadFlag = true;
    this.dataManager.patchRequest(this._addSource, postBody)
      .subscribe(
        res => {
          this.loadFlag = false;
          this.passSourceResponse(res);
        },
        error => {
          this.loadFlag = false;
          this.passSourceError(error);
        }
      );
  }
  protected abstract passSourceResponse(res);
  protected abstract passSourceError(error);
  protected abstract passResponse(response);

  protected abstract passError(error);

}
